import { Dispatch, SetStateAction } from 'react';
import { PendingRespondent } from 'src/@types/pendingRespondentStatus';
import { usePendingRespondentApi } from 'src/api/usePendingRespondentApi';
import { InputForm } from '../IdIssuanceManagementDetailForm';

type UseIdIssuanceManagementDetailFormProps = {
  selectedUser: PendingRespondent;
  setSelectedUser: Dispatch<SetStateAction<PendingRespondent | undefined>>;
};

export const useIdIssuanceManagementDetailForm = ({ selectedUser, setSelectedUser }: UseIdIssuanceManagementDetailFormProps) => {
  const { issue } = usePendingRespondentApi();

  const onSubmit = async (formData: InputForm): Promise<void> => {
    const { subject, content, password } = formData;
    const contentWithPassword = content.replaceAll('{PASSWORD}', password);
    try {
      await issue(selectedUser.id, { subject, content: contentWithPassword });
      setSelectedUser(undefined);
    } catch {
      // NOTE: エラー発生時は何もしない
    }
  };

  return { onSubmit };
};
